import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import Filters from '@app/src/pages/ResourceCollection/Filters/Filters'
import QuestionnaireFilter from '@app/src/pages/ResourceCollection/Filters/QuestionnaireFilter'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { Button, Grid } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { FiltersProps } from '..'
import TextFieldFilter from './TextFieldFilter'

interface CustomQuestionFiltersProps extends FiltersProps {
  showQuestionnaireFilter?: boolean
}

const CustomQuestionFilters = ({
  allowedFilters,
  implicitFilters,
  resetPage,
  showQuestionnaireFilter,
}: CustomQuestionFiltersProps): JSX.Element => {
  const { formatMessage } = useIntl()

  return (
    <Grid container columnSpacing={1} rowSpacing={2}>
      <Filters resetPage={resetPage} allowedFilters={allowedFilters}>
        {({ filters, clearQueryFilter }) => {
          const isFiltered = Object.keys(filters).length > 0
          return (
            <>
              <Grid item sm={8} md={2} lg={1.5} xl={1}>
                <Filter operator={Operators.EqualTo} name="id">
                  {({ filterName, value, operator }) => (
                    <TextFieldFilter
                      fullWidth
                      size="small"
                      defaultValue={value}
                      label={formatMessage({ id: 'general.id' })}
                      filterName={filterName}
                      operator={operator}
                      name="id"
                    />
                  )}
                </Filter>
              </Grid>
              <Grid
                item
                sm={8}
                md={showQuestionnaireFilter ? 4 : 6.5}
                lg={showQuestionnaireFilter ? 5 : 8}
                xl={showQuestionnaireFilter ? 5.5 : 8.5}
              >
                <Filter operator={Operators.Contains} name="questionText">
                  {({ filterName, value, operator }) => (
                    <TextFieldFilter
                      fullWidth
                      size="small"
                      defaultValue={value}
                      label={formatMessage({ id: 'schemas.question.name' })}
                      filterName={filterName}
                      operator={operator}
                      name="questionName"
                    />
                  )}
                </Filter>
              </Grid>
              {showQuestionnaireFilter && (
                <Grid item sm={8} md={2.5} lg={3} xl={3}>
                  <QuestionnaireFilter implicitFilters={implicitFilters} />
                </Grid>
              )}
              <Grid item sm={4} md={2.5} lg={2} xl={2}>
                {isFiltered && (
                  <Button variant="text" onClick={clearQueryFilter} sx={{ ml: 1 }}>
                    {formatMessage({ id: 'filters.clearAll' })}
                  </Button>
                )}
              </Grid>
            </>
          )
        }}
      </Filters>
    </Grid>
  )
}

export default CustomQuestionFilters
